import { IdLibelleModel } from "../referentiels/id.libelle.model";

/**
 * Created by cguimezanes on 01/03/17.
 */
export class IdLibelleActifModel extends IdLibelleModel {
	actif: string;
}
